import localforage from 'localforage'

class Storage {
  private db = localforage.createInstance({
    name: 'storage'
  })

  keys = {
    language: 'lang'
  } as const

  setItem<T>(key: ValueOf<typeof this.keys>, value: T) {
    return this.db.setItem(key, value)
  }

  getItem<T>(key: ValueOf<typeof this.keys>): Promise<T | null> {
    return this.db.getItem(key)
  }

  removeItem(key: ValueOf<typeof this.keys>) {
    return this.db.removeItem(key)
  }

  clear() {
    return this.db.clear()
  }
}

export default Storage
